import React, { useContext } from "react";
import {useSelector} from 'react-redux'

import LoadsModal from "./Modals/LoadsModal";
import { capitalizeFirstLetter } from "../../../../utils/helperFunc";
import Rating from "../../../../components/Rating";
import { ManageLoadPostDetailPageContext } from "../";
import LoaderImg from "../../../../assets/media/loader.gif";

const LoadPostUserInfo = ({ isLoading }) => {
  const [openModal, setOpenModal] = React.useState(false);

  const [loadPostDetailState, loadPostDetailContextDispatch] = useContext(ManageLoadPostDetailPageContext);
  const loadPostDetail = loadPostDetailState.loadPostDetail;
  const userType = useSelector(e => e?.basicInfo?.userDetails?.user_type)


  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  const handleClickOffer = () => {

    // Double time called cause trying to set the offer current amount forcefully since we have useEffect in SendOffer component
    // and it's not working when we click the offer button multiple times cause the value should be change then it's working
    loadPostDetailContextDispatch({
      type: "SET_IS_OFFER_CURRENT_AMOUNT",
      payload: 0,
    });

    setTimeout(() => {
      loadPostDetailContextDispatch({
        type: "SET_IS_OFFER_CURRENT_AMOUNT",
        payload: loadPostDetail.price_to_pay_carrier,
      });
    }, 100);

    // Scroll to the offer section
    const offerSection = document.getElementById("offer-send-box");

    console.log("offerSection", offerSection);
    if (offerSection) {
      offerSection.scrollIntoView({ behavior: "smooth" });
    }
  }

  return (
    <>
      <section id="user-loads-details">
        <div className="container theme-section">

          {
            userType === "shipper" &&
            <h1 className="section-tittle text-center mb-5">
              Load Post Details
            </h1>
          }

          {
            userType === "carrier" &&
            <h1 className="section-tittle">
              Offer Details
            </h1>
          }

          {isLoading ? (
            <div className="d-flex justify-content-center">
              <img src={LoaderImg} alt="loader" style={{ width: "35px" }} />
            </div>
          ) : (
            <div className="row user-loads-details-area">
              <div className="col-lg-6">
                <div className="loader-user-info mb-5">
                  <div className="loader-user-img">
                    <img
                      src={loadPostDetail?.shipper_obj?.profile_picture}
                      alt=""
                    />
                  </div>

                  <div>
                    <h1 className="large-text">
                      {loadPostDetail?.shipper_obj?.name}
                    </h1>
                    <div className="user-rating">
                      {!["", null, undefined].includes(
                        loadPostDetail?.shipper_obj?.avg_review_rating
                      ) && (
                        <Rating
                          rating={
                            loadPostDetail?.shipper_obj?.avg_review_rating
                          }
                        />
                      )}
                      <span>
                        ({loadPostDetail?.shipper_obj?.avg_review_rating})
                      </span>
                    </div>
                  </div>
                </div>

                <div className="user-extra-info">
                  <div className="user-extra-info-box">
                    <span>Email:</span>
                    <span>{loadPostDetail?.shipper_obj?.email}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Phone:</span>
                    <span>{loadPostDetail?.shipper_obj?.phone_number}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Country:</span>
                    <span>{loadPostDetail?.shipper_obj?.country}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>State/Region:</span>
                    <span>{loadPostDetail?.shipper_obj?.state}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>City:</span>
                    <span>{loadPostDetail?.shipper_obj?.city}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Street Address:</span>
                    <span>{loadPostDetail?.shipper_obj?.street_address}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Company:</span>
                    <span>{loadPostDetail?.shipper_obj?.company_name}</span>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <h1 className="large-text mb-5">
                  Amount: $ {loadPostDetail?.price_to_pay_carrier}
                  {userType === "carrier" &&
                    loadPostDetailState.carrierActivity?.is_already_send_offer ===
                      false && <button className="btn btn-primary btn-sm ms-3 mb-1" onClick={handleClickOffer}>
                        <p>Offer</p>
                      </button>}
                </h1>
                <div className="user-extra-info">
                  <div className="user-extra-info-box">
                    <span>Origin:</span>
                    <span>
                      {loadPostDetail?.origin_city},{" "}
                      {loadPostDetail?.origin_address},{" "}
                      {loadPostDetail?.origin_contact_name}
                    </span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Destination:</span>
                    <span>
                      {loadPostDetail?.destination_city},{" "}
                      {loadPostDetail?.destination_address},{" "}
                      {loadPostDetail?.destination_contact_name}
                    </span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Pick Up Date:</span>
                    <span>{loadPostDetail?.pickup_date_display}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Created Date:</span>
                    <span>{loadPostDetail?.created_date}</span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Load Type:</span>
                    <span>
                      {capitalizeFirstLetter(loadPostDetail?.load_type)}
                    </span>
                  </div>
                  <div className="user-extra-info-box">
                    <span>Total Loads:</span>
                    <span>{loadPostDetail?.total_loads}</span>
                  </div>
                  <div className="user-extra-info-box d-block">
                    <span>Additional Information</span>
                    <br />
                    <span>{loadPostDetail?.additional_information}</span>
                  </div>

                  <button className="view-all-loads-btn" onClick={handleOpen}>
                    View All Loads
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <LoadsModal
        openModal={openModal}
        handleClose={handleClose}
        palletLoads={loadPostDetail?.pallet}
        vehicleLoads={loadPostDetail?.vehicle}
        barrelLoads={loadPostDetail?.barrel}
        stonesLoads={loadPostDetail?.stones}
        sandLoads={loadPostDetail?.sand}
        lateriteLoads={loadPostDetail?.laterite}
        loadType={loadPostDetail?.load_type}
      />
    </>
  );
};

export default React.memo(LoadPostUserInfo);
